<template>
  <div>
    <el-form label-width="180px" class="">
      <el-row>
        <panel title="合同信息" border>
          <el-col :span="12">
            <el-form-item label="合同编号：">
              {{contractDetail.ct__contractNo}}
            </el-form-item>
            <el-form-item label="客户名称：">
               {{contractDetail.u__customerName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同状态：">
              {{contractDetail.ct__contractStatus|Status2CN}}

            </el-form-item>
            <!--<el-form-item label="供应链：">
              {{contractDetail.ct__debtorName}}
            </el-form-item>-->
            <el-form-item label="融资产品：">
              {{contractDetail.ct__productName}}
            </el-form-item>
          </el-col>
          <!--<el-col :span="24">
            <el-form-item label="融资产品：">
              {{contractDetail.ct__productName}}
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="授信起始日：">
              {{contractDetail.ct__creditValidity1|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="授信额度：">
              {{contractDetail.ct__lineOfCredit|formatMoney}} 元
            </el-form-item>
            <el-form-item label="合同起始日：">
              {{contractDetail.ct__contractValidity1|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="服务费：">
              {{contractDetail.ct__lendingFee|formatMoney}} {{contractDetail.ct__lendingFeeType == 'Rate' ? '%' : '元'}}
            </el-form-item>
            <el-form-item label="服务费收取方式：">
              {{contractDetail.ct__lendingFeeType|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授信到期日：">
              {{contractDetail.ct__creditValidity2|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="融资比例：">
              {{contractDetail.ct__financingRatio}} %
            </el-form-item>
            <el-form-item label="合同到期日：">
              {{contractDetail.ct__contractValidity2|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="融资利率：">
              {{contractDetail.ct__interestRate}} % ({{contractDetail.ct__interestType|Status2CN}})
            </el-form-item>
            <el-form-item label="利息收取节点：">
              {{contractDetail.ct__interestPayTime}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="费用收取节点：">
              {{contractDetail.ct__lendingFeePayTime}}
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>
    <panel title="附件列表">
      <files-data-table :files="contractDetail.files" />
    </panel>
  </div>
</template>

<script>
  import Panel from '../../components/Panel'
  import FilesDataTable from '../../components/FilesDataTable'
  import Status2CN from '../../filters/Status2CN'

  export default {
    name: "ContractDetailComponent",
    data() {
      return {

      }
    },
    props: {
      contractDetail: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    filters: {
      Status2CN
    },
    components: {
      Panel,
      FilesDataTable
    },
    methods: {
      downloadFile: function () {
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/ContractDetailComponent.vue